<template>
  <v-dialog v-bind="$attrs" v-on="$listeners">
    <v-card class="modal-pop modal-type-01">
      <v-card-title class="modal-title" v-show="title">
        <span>{{ $t(title) }}</span>
        <i-btn
          elevation="0"
          text
          plain
          fab
          x-small
          @click="close(false)"
          class="ml-auto px-0"
          ><v-icon
            color="#9ea5ad"
            class="material-icons-outlined"
            style="font-size:28px!important;"
            >close</v-icon
          ></i-btn
        >
      </v-card-title>

      <vue-custom-scrollbar class="modal-scroll">
        <v-card-text class="base-popup-content">
          <slot></slot>
        </v-card-text>
      </vue-custom-scrollbar>

      <slot name="actions" :close="close">
        <v-card-actions
          class="base-popup-content-actions d-flex justify-space-between"
        >
          <i-btn
            @click="close(cancelCallback)"
            :class="cancelButtonClass"
            v-show="useCancel"
            :disabled="cancelButtonDisabled"
            elevation="0"
          >
            {{ $t(cancelButtonText) }}
          </i-btn>
          <v-spacer />
          <i-btn
            @click="close(confirmCallback)"
            :class="confirmButtonClass"
            v-show="useConfirm"
            :disabled="confrimButtonDisabled"
            elevation="0"
          >
            {{ $t(confirmButtonText) }}
          </i-btn>
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    useScrollbar: {
      type: Boolean,
      default: false,
    },
    useCancel: {
      type: Boolean,
      default: true,
    },
    useConfirm: {
      type: Boolean,
      default: true,
    },
    cancelButtonText: {
      type: String,
      default: '닫기',
    },
    confirmButtonText: {
      type: String,
      default: '확인',
    },
    confirmButtonClass: {
      type: String,
      default: 'btn-type-04',
    },
    confrimButtonDisabled: {
      type: Boolean,
      default: false,
    },
    confirmCallback: {
      type: [Function, Boolean],
      default: true,
    },
    cancelCallback: {
      type: [Function, Boolean],
      default: false,
    },
    cancelButtonClass: {
      type: String,
      default: 'btn-type-09',
    },
    cancelButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async close(confirm) {
      try {
        if (typeof confirm == 'function')
          return await confirm(() => this.$emit('input', false));
        this.$emit('confirm', confirm);
        this.$emit('input', false);
      } catch (error) {
        console.error(error);
        this.$emit('input', false);
      }
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
.modal-pop.modal-type-01 .ps-container.modal-scroll {
  max-height: calc(80vh - 144px) !important;
}
</style>
